// =====================================================
// 📁 QuotationFooterActions.tsx
// =====================================================

import { Save, XCircle } from 'lucide-react';

import { useQuotation } from '../../../../../hooks/sale/useQuotation';

import POSActionButton from '../../../pos/credit-note/shared/POSActionButton';

import Can from '../../../../auth/Can';

const QuotationFooterActions = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { form, loading, create, cancel } = useQuotation();

  // =====================================================
  // 🔹 Values
  // =====================================================

  const items = form?.items || [];

  const hasProducts = items.length > 0;

  const hasQuotation = !!form?.id;

  // =====================================================
  // 🔹 Actions
  // =====================================================

  const handleSaveQuotation = async () => {
    await create();
  };

  const handleCancelQuotation = async () => {
    if (!form?.id) {
      return;
    }

    await cancel(form.id);
  };

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-3">
      {/* ===================================================== */}
      {/* 🔹 Cancel */}
      {/* ===================================================== */}

      <Can perm="QUOTATIONS_CANCEL">
        <POSActionButton
          variant="secondary"
          fullWidth
          disabled={!hasQuotation || loading}
          onClick={handleCancelQuotation}
        >
          <div className="flex items-center gap-2">
            <XCircle size={16} />
            Cancelar Cotización
          </div>
        </POSActionButton>
      </Can>

      {/* ===================================================== */}
      {/* 🔹 Save */}
      {/* ===================================================== */}

      <Can anyOf={['QUOTATIONS_CREATE', 'QUOTATIONS_EDIT']}>
        <POSActionButton
          variant="primary"
          fullWidth
          disabled={!hasProducts || loading}
          onClick={handleSaveQuotation}
        >
          <div className="flex items-center gap-2">
            <Save size={16} />
            Guardar Cotización
          </div>
        </POSActionButton>
      </Can>
    </div>
  );
};

export default QuotationFooterActions;
